<header id="masthead" class="header ttm-header-style-01" [class.sticky-header]="isSticky">
  <div class="ttm-header-wrap">
    <div id="ttm-stickable-header-w" class="ttm-stickable-header-w clearfix">
      <div id="site-header-menu" class="site-header-menu w-100">
        <div class="site-header-menu-inner ttm-stickable-header">
          <div class="container">
            <div class="site-branding">
              <a class="home-link" href="/" title="Qualibar" rel="home">
                <img id="logo-img" class="img-fluid" src="assets/images/logo.svg" alt="logo">
              </a>
            </div>
            <div id="site-navigation" class="site-navigation">
             
              <div class="ttm-menu-toggle">
                <button class="menu-toggle-btn" (click)="toggleMobileMenu()" [attr.aria-expanded]="isMobileMenuOpen">
                  <i class="ri-menu-line menu-icon-open" [class.hidden]="isMobileMenuOpen"></i>
                  <i class="ri-close-large-fill menu-icon-close" [class.hidden]="!isMobileMenuOpen"></i>
                </button>
              </div>
              <nav id="menu" class="menu" [class.mobile-menu-open]="isMobileMenuOpen">
                <ul class="dropdown">
                  <li [class.active]="isActive('/home')">
                    <a href="/home" (click)="closeMobileMenu()">Home</a>
                  </li>
                  <li class="has-submenu" [class.active]="isSectionActive('about')" [class.submenu-open]="isSubmenuOpen('about')">
                    <a href="#" (click)="toggleSubmenu('about', $event)">About Us</a>
                    <ul class="sub-menu">
                      <li [class.active]="isActive('/team')"><a href="/team" (click)="closeMobileMenu()">Management</a></li>
                      <li [class.active]="isActive('/directors-advisors')"><a href="/directors-advisors" (click)="closeMobileMenu()">Directors & Advisors</a></li>
                      <li [class.active]="isActive('/timeline')"><a href="/timeline" (click)="closeMobileMenu()">Timeline</a></li>
                    </ul>
                  </li>
                  <li class="has-submenu" [class.active]="isSectionActive('services')" [class.submenu-open]="isSubmenuOpen('services')">
                    <a href="#" (click)="toggleSubmenu('services', $event)">Services</a>
                    <ul class="sub-menu">
                      <li [class.active]="isActive('/platforms')"><a href="/platforms" (click)="closeMobileMenu()">Platforms</a></li>
                      <li [class.active]="isActive('/projects')"><a href="/projects" (click)="closeMobileMenu()">Projects</a></li>
                      <li [class.active]="isActive('/qa-service')"><a href="/qa-service" (click)="closeMobileMenu()">QA</a></li>
                      <!--<li [class.active]="isActive('/digital-marketing')"><a href="/digital-marketing">SEO/SMM</a></li>-->
                      <li [class.active]="isActive('/it-services')"><a href="/it-services" (click)="closeMobileMenu()">IT Services</a></li>
                    </ul>
                  </li>
                  <li [class.active]="isActive('/career')">
                    <a href="/career" (click)="closeMobileMenu()">Careers</a>
                  </li>
                  <li [class.active]="isActive('/contact-us')">
                    <a href="/contact-us" (click)="closeMobileMenu()">Contact Us</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
